<template>
    <div class="home">
        <!-- 轮播 -->
        <div class="loop" @mouseover="mouseOver" @mouseleave="mouseLeave">
            <div v-for='(i,index) in swiper_arr' :key="index" v-show="z_index==index">
                <img class="img" :src="i" style="transition-delay: 3s;">
            </div>
            <!-- 圆点 -->
            <div class="dot">
                <span class="span" v-for="(i,index) in swiper_arr.length" :class="{active:z_index==index}"
                    @click="dot(index)"></span>
            </div>
            <!-- 左 -->
            <div class="left" @click="left" ref="abc">&lt;</div>
            <!-- 右 -->
            <div class="right" @click="right">&gt;</div>
        </div>
        <!-- 纸搬客智能回收机001型。 -->
        <div class="one">
            <h3>纸搬客智能回收机001型。</h3>
            <router-link to="/One">
                <p>进一步了解></p>
            </router-link>
            <div class="one-details">
                <img src="../assets/img/home/2.png" alt="">
            </div>
            <div class="small-1">
                <h3>安全键</h3>
                <p>外置安全键，意外时按下开启强制安全管理</p>
            </div>
            <div class="line-1"></div>
            <div class="small-2">
                <h3>一代机屏显</h3>
                <p>15.6寸智慧大屏，内置纸搬客语音交互系统</p>
            </div>
            <div class="line-2"></div>
            <div class="small-3">
                <h3>碎纸口</h3>
                <p>碎纸时将进入“哨兵”人体自动保护机制</p>
            </div>
            <div class="line-3"></div>
            <div class="line-4"></div>
            <div class="line-11"></div>
            <div class="small-4">
                <h3>机身</h3>
                <p>机身采用防水材质，风吹雨打靠得住</p>
            </div>
            <div class="line-5"></div>
        </div>
        <!-- 纸搬客智能回收机002型。 -->
        <div class="two">
            <h3>纸搬客智能回收机002型。</h3>
            <router-link to="/Two">
                <p>进一步了解></p>
            </router-link>
            <div class="two-details">
                <img src="../assets/img/home/3.png" alt="">
            </div>
            <div class="small-5 spe">
                <h3>二代机屏显</h3>
                <p>15.6寸智慧大屏，内置纸搬客语音交互系统 </p>
            </div>
            <div class="line-6"></div>
            <div class="line-12"></div>
            <div class="small-6 spe">
                <h3>碎纸口</h3>
                <p>位置设置更合理更加方便用户投递 </p>
            </div>
            <div class="line-7"></div>
            <div class="line-13"></div>
            <div class="small-7 spe">
                <h3>新添投递口</h3>
                <p>增加书类投递口，不粉碎也一样有偿</p>
            </div>
            <div class="line-8"></div>
            <div class="line-9"></div>
            <div class="line-14"></div>
            <div class="small-8 spe">
                <h3>二代机机身</h3>
                <p>加大挡雨顶棚，机身材料进一步升级</p>
            </div>
            <div class="line-10"></div>
        </div>
        <!-- 纸搬客APP。 -->
        <div class="app">
            <div class="app-left">
                <h3>纸搬客APP。</h3>
                <p class="gray">一个可以兑现，购物，生活缴费的APP</p>
                <router-link to="/Introduce">
                    <p class="green">进一步了解></p>
                </router-link>
            </div>
            <div class="app-right">
                <img src="../assets/img/home/6.png" alt="">
            </div>
        </div>
        <!-- 社区实拍。 -->
        <div class="photoes">
            <h3>社区实拍。</h3>
            <p>纸搬客真实拍摄社区用户碎纸，BTV北京财经频道采访。</p>
            <one></one>
        </div>
        <!-- 哪款加盟合伙方式适合你？ -->
        <div class="fit">
            <h3 class="fit-h3">哪款加盟合伙方式适合你？</h3>
            <p class="fit-p1">联系纸搬客加盟专属客服</p>
            <router-link to="/Join">
                <p class="fit-p2">进一步了解>></p>
            </router-link>
            <div style="width: 100%;max-height: 2.1rem;background-color: #fff;">
                <div class="people-content">
                    <div class="content-left">
                        <img src="../assets/img/home/8.png" alt="">
                        <h3>纸搬客公益回收合伙人</h3>
                        <p>协助纸搬客在已入驻社区完成纸张的收集存放，纸搬客将按照回收重量给予补贴，同时可享受纸搬客一定福利政策，适用于物业保洁人员、社区安保人员、已退休人员，具备一定简易仓储及运输能力，具备公益责任心。
                        </p>
                        <router-link to="/Join">
                            <div class="go">去了解</div>
                        </router-link>
                    </div>
                    <div class="content-center">
                        <img src="../assets/img/home/9.png" alt="">
                        <h3>纸搬客入驻社区合伙人</h3>
                        <p>协助纸搬客，完成社区的设备入驻，纸搬客将根据社区综合情况给予入驻提成，适用于对当地社区有一定资源的渠道工作者、政府单位合作者，纸搬客将根据您可提供的资源，个性化定制合作方案。
                        </p>
                        <router-link to="/Join">
                            <div class="go">去了解</div>
                        </router-link>
                    </div>
                    <div class="content-right">
                        <img src="../assets/img/home/10.png" alt="">
                        <h3>纸搬客城市合伙人</h3>
                        <p>纸搬客为服务更多热衷于垃圾回收及环保的用户，采用分公司负责制的管理运营制度，面向全国招募分公司合伙人，如果您在合作城市有一定社会资源，并且热衷于环保公益事业，请与纸搬客联系，纸搬客将根据您的资源情况个性化定制合作方案，协助您在当地建立环保自品牌。
                        </p>
                        <router-link to="/Join">
                            <div class="go">去了解</div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- 如您的社区需要我们请填写。 -->
        <div class="write">
            <h3 style="opacity: 1;">如您的社区需要我们请填写。</h3>
            <p style="margin-bottom: 0.08rem;margin-top: 0.04rem;opacity: 1;">申请入驻</p>
            <div class="content-1">
                <div class="spe-input">
                    <input type="text" placeholder="填写您的姓名" class="input" v-model="input_1">
                    <img src="../assets/img/join/5.png" alt="" class="img-1">
                </div>
                <div class="spe-input">
                    <input type="text" placeholder="填写您的电话" class="input" oninput="value=value.replace(/[^\d]/g,'')"
                        v-model="input_2" maxlength="11">
                    <img src="../assets/img/join/6.png" alt="" class="img-2">
                </div>
                <div class="spe-input">
                    <input type="text" placeholder="填写所在地区及社区" class="input" v-model="input_3">
                    <img src="../assets/img/join/7.png" alt="" class="img-3">
                </div>
                <div class="spe-textarea">
                    <textarea cols="100" rows="100"
                        placeholder="如果您有意向加入纸搬客，请在周一至周五，早九点至下午六点致电纸搬客客服电话：010-64630081，您也可以通过本页向纸搬客留言,我们将尽快与您取得联系"
                        class="input-spe" v-model="input_4"></textarea>
                    <img src="../assets/img/join/8.png" alt="" class="img-4">
                </div>
                <div class="btn" @click="submit">提交</div>
            </div>
        </div>
        <!-- footer -->
        <footer_s></footer_s>
    </div>
</template>
<script>
    import Swiper from 'swiper'
    import one from './common/one'
    import footer_s from './common/footer'
    import $ from 'jquery'
    export default {
        name: 'home',
        components: {
            footer_s,
            one,
        },
        data() {
            return {
                z_index: 0, //记录下标位置
                swiper_arr: [
                    require('../assets/img/home/1.png'),
                    require('../assets/img/home/23.png'),
                    require('../assets/img/home/24.png'),
                ],
                timer: null,
                loop_arr: [
                    require('../assets/img/home/15.png'),
                    require('../assets/img/home/16.png'),
                    require('../assets/img/home/17.png'),
                    require('../assets/img/home/18.png'),
                    require('../assets/img/home/19.png'),
                    require('../assets/img/home/20.png'),
                ],
                input_1: '',
                input_2: '',
                input_3: '',
                input_4: '',
            }
        },
        created() {
            this.autoPlay();
        },
        mounted() {
            this.ani()
        },
        watch: {
            input_1(newI, old) {
                if (this.newI == '') {
                    this.Toast({
                        message: "姓名不能为空！",
                        duration: 2000
                    });
                }
            },
            input_2(newI, old) {
            },
            input_3(newI, old) {
                if (this.newI == '') {
                    this.Toast({
                        message: "地区不能为空！",
                        duration: 2000
                    });
                }
            },
            input_4(newI, old) {
                if (this.newI == '') {
                    this.Toast({
                        message: "内容不能为空！",
                        duration: 2000
                    });
                }
            }
        },
        methods: {
            // 提交
            submit() {
                if (this.input_1 == '') {
                    this.Toast({
                        message: "姓名不能为空！",
                        duration: 2000
                    });
                    return false;
                }
                if (this.input_2 == '') {
                    this.Toast({
                        message: "电话号码不能为空！",
                        duration: 2000
                    });
                    return false;
                }
                if (this.input_3 == '') {
                    this.Toast({
                        message: "地区不能为空！",
                        duration: 2000
                    });
                    return false;
                }
                var expressMobile = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
                if (!expressMobile.test(this.input_2)) {
                    this.Toast({
                        title: "输入错误",
                        message:
                            "请输入正确的手机号码"
                    });
                } else {
                    var that = this;
                    $.ajax({
                        url: 'https://webservice.paperbanker.com/biz/paperConsultation', //测试地址 http://47.92.104.146/
                        // url: 'http://47.92.104.146/biz/paperConsultation', //测试地址 http://47.92.104.146/
                        type: "post",
                        data: {
                            name: this.input_1,
                            phone: this.input_2,
                            address: this.input_3,
                            remarks: this.input_4
                        },
                        dataType: "json",
                        success: function (data) {
                            that.Toast({
                                title: "提示",
                                message: data.message
                            });
                        },
                    })
                }
            },
            ani() {
                $(window).scroll(function () {
                    var scroll = $(window).scrollTop(); //滚动的高度
                    var ViewHeight = $(window).height(); //视口的高度
                    var OneHeight = $('.one').offset().top; //元素的高度
                    var TwoHeight = $('.two').offset().top;
                    var AppHeight = $('.app').offset().top;
                    var FitHeight = $('.fit').offset().top;
                    if (scroll + ViewHeight >= OneHeight) {
                        $('.one h3,.one p,.one-details img,.line-1,.line-2,.line-3,.line-4,.line-5,.line-11').animate({
                            opacity: 1
                        }, 3000)
                        $('.small-1,.small-3').addClass('animated slideInLeft');
                        $('.small-2,.small-4').addClass('animated slideInRight');
                    }
                    if (scroll + ViewHeight >= TwoHeight) {
                        $('.two h3,.two p,.two-details img,.line-7,.line-8,.line-9,.line-10,.line-6').animate({
                            opacity: 1
                        }, 3000)
                        $('.small-5,.small-7').addClass('animated slideInLeft');
                        $('.small-6,.small-8').addClass('animated slideInRight');
                    }
                    if (scroll + ViewHeight >= AppHeight) {
                        $('.app-left h3,.gray,.green').addClass('animated rotateInDownLeft').animate({
                            opacity: 1
                        }, 3000);
                        $('.app-right img').addClass('animated rotateInDownRight');
                    }
                    if (scroll + ViewHeight >= FitHeight) {
                        $('.fit h3,.fit-p1,.fit-p2').animate({
                            opacity: 1
                        }, 3000)
                        $('.people-content').addClass('animated bounceInUp')
                    }
                })
            },
            //左
            left() {
                this.z_index--;
                if (this.z_index <= -1) {
                    this.z_index = this.swiper_arr.length - 1;
                }
            },
            //右
            right() {
                this.z_index++;
                if (this.z_index == this.swiper_arr.length) {
                    this.z_index = 0;
                }
            },
            //点
            dot(fn) {
                this.z_index = fn;
            },
            autoPlay() {
                this.timer = setInterval(() => {
                    this.z_index++;
                    if (this.z_index > this.swiper_arr.length - 1) {
                        this.z_index = 0;
                    }
                }, 2000)
            },
            mouseOver() {
                clearInterval(this.timer);
            },
            mouseLeave() {
                this.autoPlay();
            }
        },
        beforeDestroy() {
            $(window).off('scroll')
        }
    }
</script>
<style scoped>
    .content-left:hover,
    .content-center:hover,
    .content-right:hover {
        cursor: pointer;
        transform: scale(1.05);
    }

    .home {
        width: 100%;
        height: 100%;
    }

    /* 轮播 */
    .loop {
        width: 100%;
        height: 1.93rem;
        position: relative;
    }

    .left,
    .right {
        width: 0.14rem;
        height: 0.14rem;
        border-radius: 50%;
        text-align: center;
        line-height: 0.13rem;
        font-size: 0.1rem;
        z-index: 10;
        position: absolute;
        top: 0.84rem;
        cursor: pointer;
        border: 0.001rem solid #535353;
        color: #535353;
    }

    .left:hover,
    .right:hover {
        border: 0.001rem solid #ffffff;
        color: #fff;
    }

    .img {
        width: 100%;
        height: 1.93rem;
        position: absolute;
        top: 0;
        left: 0;
    }

    .left {
        left: 0.71rem;
    }

    .right {
        right: 0.71rem;
    }

    .dot {
        height: 0.04rem;
        border-radius: 10px;
        position: absolute;
        left: 50%;
        bottom: 0.2rem;
        margin-left: -0.5rem;
    }

    .span {
        display: inline-block;
        width: 0.04rem;
        height: 0.04rem;
        background: #535353;
        border-radius: 50%;
        cursor: pointer;
        margin-left: 0.19rem;
    }

    .active {
        background: #fff;
    }

    /* 机型1,2 */
    .one,
    .two {
        width: 100%;
        min-height: 1.77rem;
        background-color: #000;
        padding: 0.08rem 0;
        margin-top: 0.03rem;
        position: relative;
    }

    .two {
        background-color: #F5F5F7;
    }

    .one h3,
    .one p,
    .one-details img,
    .line-1,
    .line-2,
    .line-3,
    .line-4,
    .line-5,
    .line-6,
    .line-7,
    .line-8,
    .line-9,
    .line-10,
    .line-11 {
        opacity: 0;
    }

    .one h3,
    .two h3 {
        font-size: 0.12rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 0.2rem;
        text-align: center;
        opacity: 0;
    }

    .two h3 {
        color: rgba(55, 55, 55, 1);
    }

    .one p,
    .two p {
        font-size: 0.05rem;
        font-family: PingFang SC;
        text-decoration: underline;
        color: rgba(44, 194, 142, 1);
        text-align: center;
        cursor: pointer;
        opacity: 0;
    }

    .one-details,
    .two-details {
        width: 100%;
        height: 1.3rem;
        position: relative;
    }

    .one-details img {
        width: 0.85rem;
        height: 1.13rem;
        position: absolute;
        top: 0.1rem;
        left: 50%;
        margin-left: -0.42rem;
        opacity: 0;
    }

    .two-details img {
        width: 0.95rem;
        height: 1.12rem;
        position: absolute;
        top: 0.11rem;
        left: 50%;
        margin-left: -0.47rem;
    }

    .small-1,
    .small-2,
    .small-3,
    .small-4,
    .small-5,
    .small-6,
    .small-7,
    .small-8 {
        width: 0.55rem;
        min-height: 0.28rem;
        background: rgba(15, 15, 15, 1);
        border: 0.02rem solid rgba(38, 38, 38, 1);
        position: absolute;
        padding: 0.02rem 0;
    }

    .small-1,
    .small-5 {
        top: 0.55rem;
        left: 0.71rem;
    }

    .small-2,
    .small-6 {
        top: 0.54rem;
        right: 0.71rem;
    }

    .small-3,
    .small-7 {
        top: 1.18rem;
        left: 0.71rem;
    }

    .small-4,
    .small-8 {
        top: 1.18rem;
        right: 0.71rem;
    }

    .small-1 h3,
    .small-2 h3,
    .small-3 h3,
    .small-4 h3,
    .small-5 h3,
    .small-6 h3,
    .small-7 h3,
    .small-8 h3 {
        font-size: 0.06rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 0.08rem;
    }

    .small-1 p,
    .small-2 p,
    .small-3 p,
    .small-4 p,
    .small-5 p,
    .small-6 p,
    .small-7 p,
    .small-8 p {
        font-size: 0.04rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        text-decoration: none;
        padding: 0 0.03rem;
    }

    .spe {
        width: 0.54rem;
        min-height: 0.18rem;
        background: rgba(204, 204, 204, 1);
        border: 0.02rem solid rgba(177, 177, 177, 1);
    }

    .line-1 {
        width: 0.37rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(255, 255, 255, 1);
        position: absolute;
        top: 0.64rem;
        left: 1.25rem;
    }

    .line-2 {
        width: 0.54rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(255, 255, 255, 1);
        position: absolute;
        top: 0.68rem;
        right: 1.26rem;
    }

    .line-3 {
        width: 0.195rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(255, 255, 255, 1);
        position: absolute;
        top: 1.319rem;
        left: 1.26rem;
    }

    .line-4 {
        width: 0.18rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(255, 255, 255, 1);
        position: absolute;
        top: 0.88rem;
        left: 1.45rem;
    }

    .line-11 {
        width: 0.001rem;
        height: 0.44rem;
        border: 0.001rem solid rgba(255, 255, 255, 1);
        position: absolute;
        top: 0.88rem;
        left: 1.45rem;
    }

    .line-5 {
        width: 0.35rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(255, 255, 255, 1);
        position: absolute;
        top: 1.31rem;
        right: 1.26rem;
    }

    .line-6 {
        width: 0.35rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(177, 177, 177, 1);
        position: absolute;
        top: 0.84rem;
        left: 1.17rem;
    }

    .line-12 {
        width: 0.001rem;
        height: 0.05rem;
        border: 0.001rem solid rgba(177, 177, 177, 1);
        position: absolute;
        top: 0.79rem;
        left: 1.17rem;
    }

    .line-7 {
        width: 0.35rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(177, 177, 177, 1);
        position: absolute;
        top: 0.85rem;
        right: 1.17rem;
    }

    .line-13 {
        width: 0.001rem;
        height: 0.05rem;
        border: 0.001rem solid rgba(177, 177, 177, 1);
        position: absolute;
        top: 0.8rem;
        right: 1.17rem;
    }

    .line-8 {
        width: 0.13rem;
        height: 0.1rem;
        border: 0.001rem solid rgba(177, 177, 177, 1);
        border-right: none;
        border-left: none;
        border-bottom: none;
        position: absolute;
        top: 1.3rem;
        left: 1.243rem;
    }

    .line-9 {
        width: 0.13rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(177, 177, 177, 1);
        position: absolute;
        top: 1rem;
        left: 1.37rem;
    }

    .line-14 {
        width: 0.001rem;
        height: 0.3rem;
        border: 0.001rem solid rgba(177, 177, 177, 1);
        position: absolute;
        top: 1rem;
        left: 1.37rem;
    }

    .line-10 {
        width: 0.3rem;
        height: 0.001rem;
        border: 0.001rem solid rgba(177, 177, 177, 1);
        position: absolute;
        top: 1.3rem;
        right: 1.25rem;
    }

    /* 纸搬客app */
    .app {
        width: 100%;
        height: 1.39rem;
        background-color: #fff;
        border: 0.03rem solid #fff;
        overflow: hidden;
    }

    .app-left {
        width: 50%;
        height: 1.39rem;
        background-color: #F5F5F7;
        float: left;
        margin-right: 1%;
        text-align: center;
        padding-top: 0.4rem;
    }

    .app-left h3,
    .fit-h3,
    .write h3 {
        font-size: 0.12rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        opacity: 0;
    }

    .fit-p1,
    .write p,
    .gray {
        font-size: 0.05rem;
        font-family: PingFang SC;
        color: #7B7B7B;
        line-height: 0.09rem;
        font-weight: bold;
        opacity: 0;
    }

    .fit-p2,
    .green {
        font-size: 0.05rem;
        font-family: PingFang SC;
        text-decoration: underline;
        color: rgba(44, 194, 142, 1);
        line-height: 0.09rem;
        cursor: pointer;
        opacity: 0;
    }

    .app-right {
        width: 49%;
        height: 1.39rem;
        background-color: #F5F5F7;
        float: left;
        position: relative;
    }

    .app-right img {
        width: 1.1rem;
        height: 1.1rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.55rem;
        margin-left: -0.55rem;
    }

    /* 社区实拍 */
    .photoes {
        width: 100%;
        height: 2.05rem;
        text-align: center;
        padding-top: 0.1rem;
    }

    .photoes h3 {
        font-size: 0.12rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        line-height: 0.22rem;
        letter-spacing: 0.01rem;
    }

    .photoes p {
        font-size: 0.05rem;
        font-family: PingFang SC;
        color: rgba(123, 123, 123, 1);
        line-height: 0.09rem;
        font-weight: bold;
    }

    .photoes img {
        width: 97%;
        height: 1.11rem;
        margin-top: 0.04rem;
    }

    /* 适合 */
    .fit {
        width: 100%;
        min-height: 1.79rem;
        border-top: 0.03rem solid #F5F5F7;
        text-align: center;
        padding: 0.1rem 0;
        background-color: #fff;
        overflow: hidden;
    }

    .people-content {
        width: 60%;
        min-height: 1.36rem;
        margin: 0 auto;
        padding-top: 0.06rem;
        background-color: #fff;
    }

    .people-content img {
        width: 100%;
        height: 0.45rem;
        margin-bottom: 0.1rem;
    }

    .people-content h3 {
        font-size: 0.05rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        line-height: 0.13rem;
        text-align: center;
    }

    .people-content p {
        font-size: 0.035rem;
        font-family: PingFang SC;
        /* font-weight: bold; */
        color: rgba(128, 128, 128, 1);
        text-align: center;
        padding: 0 0.04rem;
        line-height: 0.05rem;
    }

    .content-left,
    .content-center,
    .content-right {
        width: 30%;
        height: 1.36rem;
        background-color: #F5F5F7;
        float: left;
        margin-right: 3.5%;
        border-radius: 0.03rem;
        position: relative;
        padding-bottom: 0.2rem;
    }

    .content-right {
        margin-right: 0;
    }

    .go {
        width: 0.26rem;
        height: 0.08rem;
        background: rgba(44, 194, 142, 1);
        border-radius: 0.02rem;
        font-size: 0.03rem;
        font-family: PingFang SC;
        text-decoration: none;
        color: rgba(255, 255, 255, 1);
        line-height: 0.08rem;
        text-align: center;
        /* margin: 0.05rem auto; */
        position: absolute;
        left: 50%;
        margin-left: -0.13rem;
        bottom: 0.05rem;
    }

    /* 需要填写 */
    .write {
        width: 100%;
        min-height: 1.79rem;
        text-align: center;
        background-color: #F5F5F7;
        padding-top: 0.08rem;
    }

    .content-1 {
        width: 1.46rem;
        min-height: 1.27rem;
        margin: 0 auto;
        position: relative;
    }

    .spe-input {
        width: 1.46rem;
        height: 0.15rem;
        margin-bottom: 0.04rem;
        position: relative;
    }

    .input {
        width: 1.46rem;
        height: 0.15rem;
        background-color: #ffffff;
        font-size: 0.04rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(195, 195, 195, 1);
        padding-left: 0.17rem;
        border-radius: 0.02rem;
        display: block;
        /*自带margin-top */
    }

    .spe-textarea {
        width: 1.46rem;
        height: 0.42rem;
        position: relative;
    }

    .input-spe {
        width: 1.46rem;
        height: 0.42rem;
        background-color: #fff;
        font-size: 0.04rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(195, 195, 195, 1);
        line-height: 0.06rem;
        padding: 0.04rem 0.08rem 0 0.17rem;
        border-radius: 0.02rem;
        margin-top: 0.06rem;
        display: block;
    }

    .img-1 {
        width: 0.06rem;
        height: 0.06rem;
        position: absolute;
        top: 50%;
        left: 0.06rem;
        margin-top: -0.03rem;
    }

    .img-2 {
        width: 0.05rem;
        height: 0.06rem;
        position: absolute;
        top: 50%;
        left: 0.06rem;
        margin-top: -0.03rem;
    }

    .img-3 {
        width: 0.04rem;
        height: 0.06rem;
        position: absolute;
        top: 50%;
        left: 0.06rem;
        margin-top: -0.03rem;
    }

    .img-4 {
        width: 0.04rem;
        height: 0.05rem;
        position: absolute;
        top: 11%;
        left: 0.06rem;
        /* margin-top: -0.025rem; */
    }

    .btn {
        width: 0.9rem;
        height: 0.15rem;
        background-color: #39cfa1;
        border-radius: 0.03rem;
        font-size: 0.07rem;
        margin: 0 auto;
        text-align: center;
        line-height: 0.15rem;
        color: #fff;
        margin-top: 0.04rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/home.vue